import { oc } from "@orpc/contract";
import { z } from "zod";

// Current-environment LiteLLM spend + budget, read from the proxy's /key/info
// for this env's virtual key. `configured` is false when LITELLM_PROXY_URL /
// LITELLM_VIRTUAL_KEY are unset (routing disabled) — the page then shows a
// "not configured" notice instead of zeros.
export const AiSpendSummarySchema = z.object({
  configured: z.boolean(),
  environment: z.string().nullable(),
  keyAlias: z.string().nullable(),
  spend: z.number().nullable(),
  maxBudget: z.number().nullable(),
  budgetResetAt: z.string().nullable(),
  models: z.array(z.string()),
});

export type AiSpendSummary = z.infer<typeof AiSpendSummarySchema>;

export const aiUsageContracts = {
  get: oc.output(AiSpendSummarySchema).route({ method: "GET" }),
} as const;
